import { render, staticRenderFns } from "./InvoiceFooterBar.vue?vue&type=template&id=539d9832&"
import script from "./InvoiceFooterBar.vue?vue&type=script&lang=js&"
export * from "./InvoiceFooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports